import { API_BASE_URL } from '@/config/site'

const ABSOLUTE_URL_REGEXP = /^(https?:)?\/\//i

export const resolveAssetUrl = (value) => {
  if (!value) {
    return ''
  }

  if (ABSOLUTE_URL_REGEXP.test(value) || value.startsWith('data:')) {
    return value
  }

  if (!API_BASE_URL || API_BASE_URL === '/') {
    return value
  }

  const normalizedBase = API_BASE_URL.replace(/\/+$/, '')
  const normalizedPath = value.startsWith('/') ? value : `/${value}`

  return `${normalizedBase}${normalizedPath}`
}

export const formatDuration = (seconds) => {
  const totalSeconds = Number(seconds) || 0
  const hour = Math.floor(totalSeconds / 3600)
  const minute = Math.floor((totalSeconds % 3600) / 60)
  const second = totalSeconds % 60

  if (hour > 0) {
    return `${hour}h ${String(minute).padStart(2, '0')}m`
  }

  if (minute > 0) {
    return `${minute}m ${String(second).padStart(2, '0')}s`
  }

  return `${second}s`
}
